import { Checkbox } from '@audio-network/componentlibrary'
import React from 'react'
import clsx from 'clsx'
import styles from './SelectNumber.module.css'

interface SelectNumberProps {
	selected?: boolean
	selectAlwaysVisible?: boolean
	setTrackSelected?: (track: Track) => void
	track?: Track
}

const SelectNumber = ({
	selected,
	selectAlwaysVisible = false,
	setTrackSelected,
	track,
}: SelectNumberProps): JSX.Element => {
	return (
		<>
			{setTrackSelected && (
				<Checkbox
					className={clsx(
						styles.checkbox,
						selectAlwaysVisible && styles.alwaysVisible
					)}
					checked={selected}
					onChange={() => setTrackSelected(track)}
					value={track.title}
					aria-label={track.title}
					label=""
					name={`${track.title}-checkbox`}
				/>
			)}
		</>
	)
}

export default SelectNumber
